import { useTranslation } from "react-i18next";
import OrderModal, {
  ModalType,
} from "../../../../../components/OrderModal/OrderModal";

const ContinueToNextWarningOrderModal = ({
  open,
  closeModal,
  primaryButtonClick,
  noValidLines,
  hasMissingSerialNumbers = false,
}: ModalType & {
  noValidLines: boolean;
  hasMissingSerialNumbers?: boolean;
}) => {
  const { t } = useTranslation(["orders", "common"]);

  const getDescription = () => {
    if (hasMissingSerialNumbers) {
      return t(
        "orders:modal.missingSerialNumbersWarningOrderModal.description"
      );
    }
    if (noValidLines) {
      return t("orders:modal.noValidLinesWarningOrderModal.description");
    }
    return t("orders:modal.continueToNextWarningOrderModal.description");
  };

  const shouldBlockProceed = noValidLines || hasMissingSerialNumbers;

  return (
    <>
      <OrderModal
        data-testid="continue-to-next-order-modal"
        openModal={open}
        title={t("common:button.continueToNext")}
        description={getDescription()}
        primaryButtonName={
          shouldBlockProceed
            ? t("orders:modal.noValidLinesWarningOrderModal.button.okay")
            : t("orders:modal.continueToNextWarningOrderModal.button.continue")
        }
        secondaryButtonName={t("common:modal.cancelBtn")}
        closeModalFn={closeModal}
        onPrimaryButtonClick={
          shouldBlockProceed ? closeModal : primaryButtonClick
        }
        hideSecondaryButton={shouldBlockProceed}
      />
    </>
  );
};

export default ContinueToNextWarningOrderModal;
